import React, { Fragment, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';
import { SmartBanner } from '../../components/organism/SmartBanner';
import VimeoErrorModal from '../../components/organism/VimeoErrorModal';
import ErrorPage from '../../components/templates/ErrorPage';
import { IMainTemplate } from '../../models';
import BottomMenu from './components/bottomMenu/bottomMenu';
import MenuBar from './components/menuBar';
import { isMenuPlanoAdaptativoNotShowBottomMenu } from '../../utils/menu';
import {
  BlackFridayFaixaBanner,
  BlackFridayWidget,
} from '../../../modules/Gamification/components/Common/BlackFriday';

const Template: React.FC<IMainTemplate> = ({ children, childrenPadding }) => {
  const { pathname } = useLocation();

  // Banner da campanha Black fica abaixo do header em todas as páginas, exceto
  // a Minha Área (renderizada em "/" e "/minha-area"), que tem o fundo próprio.
  const esconderBannerBlack =
    pathname === '/' || pathname.startsWith('/minha-area');

  const showMenu = () => {
    if (
      (pathname.includes('conteudo') &&
        (pathname.includes('videoaula') || pathname.includes('material'))) ||
      (pathname.includes('simulados') && pathname.includes('revisao')) ||
      (pathname.includes('redacoes') && pathname.includes('start')) ||
      (pathname.includes('redacoes') && pathname.includes('escrevendo')) ||
      isMenuPlanoAdaptativoNotShowBottomMenu()
    ) {
      return false;
    }

    if (pathname.includes('aprova-live/') || pathname.includes('lives/')) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  const ErrorFallback = () => {
    return <ErrorPage />;
  };

  const logError = (error: any) => {
    console.error(error);
  };

  return (
    <ErrorBoundary onError={logError} FallbackComponent={ErrorFallback}>
      <VimeoErrorModal />
      {/* Widget flutuante da campanha Black — em todas as páginas (só para elegíveis) */}
      <BlackFridayWidget />
      <div className='flex min-h-screen flex-col'>
        <div className='fixed top-0 z-10 w-full'>
          <MenuBar />
          <SmartBanner />
        </div>

        {showMenu() ? (
          <Fragment>
            <div
              className={`
                mt-16 min-h-[calc(100vh-134px)] w-full bg-color-lighter lg:min-h-[calc(100vh-64px)]
                ${!pathname.includes('/exercicio/') ? 'mb-[70px]' : ''} lg:mb-0 ${childrenPadding}
              `}
            >
              {!esconderBannerBlack && <BlackFridayFaixaBanner />}
              {children}
            </div>

            <div className='fixed bottom-0 z-10 w-full'>
              <BottomMenu />
            </div>
          </Fragment>
        ) : (
          <div
            className={`mt-16 min-h-screen w-full bg-color-lighter md:mb-0 ${childrenPadding}`}
          >
            {!esconderBannerBlack && <BlackFridayFaixaBanner />}
            {children}
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};

export default Template;
